module.exports = __webpack_public_path__ + "img/281.95c44207.svg";